import React, { useEffect, useState } from 'react';
import ResultTable from '../ResultTable/ResultTable'
import styled from 'styled-components'
import Header from '../Header/Header'
import { Black, Shadow, WerfenColor } from '../../Constants/ColorChart'
import { useParams } from 'react-router-dom'
import { connect } from 'react-redux'
import { hideSearchBar, setTitleBar, showBackArrow, showDialog } from "../../../actions/ui";
import Loader from '../Loader/Loader'
import Dialog from "../Dialog/Dialog";
import { DocumentsFolder } from "../../Constants/AppData";
import { formatBytes } from "../../../../web/Utils/utils";

import isElectron from 'is-electron'

let electron;

if ( isElectron() ) {
    electron = window.require( "electron" )
}
const ipcRenderer = electron && electron.ipcRenderer;

/*
 *  @Description:   Component that renders a resource.
 */

const RelativeDiv = styled.div`
    position: relative;
    .available_offline_resource td:last-of-type{
        width: 180px;
    }
`;

const TableWrapper = styled.div`
  margin-top: 3%;
`;

const OfflineResource = ( props ) => {
    const [ resource, setResource ] = useState( null );
    const id = useParams().id;

    useEffect( () => {
        props.hideSearchBar();
        props.setTitleBar( "Offline Resource" );
        props.showBackArrow();

        if ( isElectron() ) {
            ipcRenderer.send( 'getDetailsForOfflineResource', id )
            ipcRenderer.on( 'finishedGettingOfflineResource', setOfflineResource );
        }
        return () => {
            if ( isElectron() ) {
                ipcRenderer.off( 'finishedGettingOfflineResource', setOfflineResource );
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );


    const setOfflineResource = ( event, resource ) => {
        const docs = getDocuments( resource );
        const separatedFiles = separateDefaultFile( docs );
        const output = {
            id: resource[0].id,
            title: resource[0].name,
            description: resource[0].description,
            docs,
            isInPlaylist: resource.isInPlaylist,
            separatedFiles,
            elementCounter: resource.length,
            resourceIsDownloaded: true,
            isResourceSet: true
        }
        setResource( output );
    }

    const getDocuments = ( resource ) => {
        let documentsURI = `file://${ DocumentsFolder }`;

        if ( window.location.protocol === "http:" ) {
            documentsURI = `http://localhost:9990/`
        }

        return resource.map( ( file, index ) => {
            return {
                metadata: {
                    name: file.doc_name,
                    size: file.filesize && file.filesize !== "N/A" ? formatBytes( file.filesize ) : "N/A",
                    mimetype: file.doc_format,
                    format: file.doc_format,
                    entityChanged: file.doc_entity_changed,
                    entityBundle: file.entityBundle,
                    fileIndex: index
                },
                file: documentsURI + file.doc_uuid,
                url: documentsURI + file.doc_uuid,
                id: file.id.toString(),
                format: file.doc_format,
                file_id: file.doc_id,
                media_uuid: file.doc_uuid,
                entityBundle: file.entityBundle,
                actions: {
                    isDownloaded: true,
                },
                activities: {
                    canSaveAs: true,
                    canOpenInViewer: file.doc_format === "PDF",
                },
                contextActions: [],
                saveAs: true
            }
        } )
    }

    const separateDefaultFile = ( docs ) => {

        let tableData = [];
        let headerData = [];

        docs &&
        docs.map( ( data, index ) => (
            index === 0 ? headerData.push( data ) : tableData.push( data )
        ) );

        return { dataForTable: tableData, dataForHeader: headerData };
    }

    return (
        <div>
            {
                !resource &&
                <Loader
                    message="Loading"
                    primaryColor={ WerfenColor }
                    secondaryColor={ Shadow }
                    fontColor={ Black }
                    extraStyle="margin-top: 10%"
                />
            }
            {
                resource &&
                <>
                    <RelativeDiv className={ "RelativeDiv" }>
                        <Header
                            upperMiniTitle={ "Offline Resource" }
                            title={ resource && decodeURIComponent( resource.title ) }
                            description={ (resource && resource.description) ? decodeURIComponent( resource.description ) : "" }
                            availableOffline={ true }
                            elementCounter={ resource.elementCounter }
                            resource={ resource || {} }
                            itemId={ resource.id || id.toString() }
                            offline={ true }
                            goBack={ true }
                            // downloadCounter={ resource.downloadCounter }
                            // isFav={ resource.isFav }
                            // actionToChangeFav={ setFavoriteResourceStatus }
                        />
                    </RelativeDiv>
                    <RelativeDiv className={ "RelativeDiv" }>
                        <TableWrapper>
                            <ResultTable
                                centered
                                rowWidth={ 40 }
                                title={ "" }
                                fieldsToShow={ [ "", "name", "size", "format" ] }
                                data={ resource.separatedFiles.dataForHeader }
                                type={ "available_offline_resource" }
                                tableUnified={false}
                            />
                        </TableWrapper>
                    </RelativeDiv>
                    {
                        resource.separatedFiles.dataForTable.length > 0 &&
                        <RelativeDiv className={ "RelativeDiv" }>
                            <TableWrapper>
                                <ResultTable
                                    centered
                                    rowWidth={ 40 }
                                    // title={ table.title }
                                    title={ "Other components for this resource" }
                                    fieldsToShow={ [ "", "name", "size", "format" ] }
                                    data={ resource.separatedFiles.dataForTable }
                                    type={ "available_offline_resource" }
                                    tableUnified={false}
                                />
                            </TableWrapper>
                        </RelativeDiv>
                    }
                </>
            }
            {
                props.dialogVisible &&
                <Dialog/>
            }
        </div>
    );
}

const mapStateToProps = ( state ) => ({
    resource: state.resource,
    session: state.session,
    dialogVisible: state.ui.dialogVisible
});
export default connect( mapStateToProps, {
    showDialog,
    showBackArrow,
    setTitleBar,
    hideSearchBar,
} )( OfflineResource );
